import script from "./TarjetaClase.vue?vue&type=script&setup=true&lang=js"
export * from "./TarjetaClase.vue?vue&type=script&setup=true&lang=js"

import "./TarjetaClase.vue?vue&type=style&index=0&id=5d01f3a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d01f3a7"]])

export default __exports__